import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { shortLinkTarget } from '@/services/coach-client';

/**
 * /go/:code: the short link in sign-in, purchase and reset emails, on the
 * portal's own domain. The code lives on the coach worker, so hand it over
 * there; the worker redirects straight back into the portal (/auth-callback or
 * /reset-password) carrying the one-time token, or to /auth when it expired.
 */
export default function GoLinkPage() {
  const { code = '' } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const target = shortLinkTarget(code);
    if (target) window.location.replace(target);
    else navigate('/auth?link=expired', { replace: true });
  }, [code, navigate]);
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#050507', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
      <Spinner size="lg" />
      <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)' }}>Opening your link…</p>
    </div>
  );
}
